




















import { Form } from "view-design";
import { Component, Vue } from "vue-property-decorator";
import { chargeStatus, backMoney, backRole, redelivery } from "@/req/gameManage";
@Component({
  components: {},
})
export default class Home extends Vue {
  public delShow = false;
  public gameId: any = "";
  public limit: any = 0;
  public list: any = ["确定停用该游戏", "确定启用该游戏", "确定删除该游戏", "确定要退款", "确定要退角色", '确认对商品进行再次发货吗？'];
  public show(shows, gameId, state) {
    this.gameId = gameId;
    this.limit = state;
    this.delShow = shows;
  }
  public async submit(type) {
    if (this.limit == 1 || this.limit == 2 || this.limit == 3) {
      const res = await chargeStatus({
        box_game_id: this.gameId,
        type: this.limit,
      });
      if (res.code == 0) {
        this.$Message.success(res.msg);
        this.$emit("getList");
      }
    }
    if (this.limit == 4) {
      const res = await backMoney({
        id: this.gameId,
      });
      if (res.code == 0) {
        this.$Message.success(res.msg);
        this.$emit("getList");
      }
    }
    if (this.limit == 5) {
      const res = await backRole({
        id: this.gameId,
      });
      if (res.code == 0) {
        this.$Message.success(res.msg);
        this.$emit("getList");
      }
    }
    if (this.limit == 6) {
      const res = await redelivery({
        order_id: this.gameId,
      });
      if (res.code == 0) {
        this.$Message.success(res.msg);
        this.$emit("getList");
      }
    }
    this.delShow = false;
  }
}
